import { ObjectGroup } from "contexts/objectGroups";

import { ObjectGroupExt } from "./types";

export function getCollections(objectGroups: ObjectGroupExt[], collectionPrefix: string, locale: string) {
    const names: string[] = [];
    const groups = new Map<string, ObjectGroupExt[]>();

    for (const group of objectGroups) {
        if (group.grouping === "" || !group.grouping.startsWith(collectionPrefix)) {
            continue;
        }
        const relativeCollections = group.grouping.substring(collectionPrefix.length);
        const nextSlash = relativeCollections.indexOf("/");
        const collection =
            nextSlash === -1 ? group.grouping : group.grouping.substring(0, collectionPrefix.length + nextSlash);

        let collectionGroups = groups.get(collection);
        if (!collectionGroups) {
            collectionGroups = [];
            groups.set(collection, collectionGroups);
            names.push(collection);
        }
        collectionGroups.push(group);
    }

    names.sort((a, b) => a.localeCompare(b, locale, { sensitivity: "accent" }));
    return names.map((collection) => ({ collection, groups: groups.get(collection)! }));
}

export function getCollectionNames(objectGroups: ObjectGroup[], locale: string) {
    return Array.from(
        objectGroups.reduce((set, grp) => {
            if (grp.grouping) {
                grp.grouping.split("/").forEach((_collection, idx, arr) => {
                    set.add(arr.slice(0, -idx).join("/"));
                });

                set.add(grp.grouping);
            }

            return set;
        }, new Set<string>()),
    )
        .filter((collection) => collection !== "")
        .sort((a, b) => a.localeCompare(b, locale, { sensitivity: "accent" }));
}
